(function () {
  function initCard(card) {
    var swatches = card.querySelectorAll(".klar-product-card__swatch");
    if (!swatches.length) return;

    var mainImg = card.querySelector("[data-klar-main-img]");
    var variantInput = card.querySelector('input[name="id"]');
    var isBundleCard = !!card.querySelector("[data-klar-bundle-swatches]");

    if (isBundleCard) {
      // Parse embedded variants JSON for multi-option matching
      var variantsEl = card.querySelector("[data-klar-variants]");
      var variants = [];
      if (variantsEl) {
        try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}
      }

      swatches.forEach(function (swatch) {
        swatch.addEventListener("click", function () {
          var optionIndex = parseInt(swatch.getAttribute("data-option-index"), 10);

          // Update active only within this option group
          card.querySelectorAll('.klar-product-card__swatch[data-option-index="' + optionIndex + '"]').forEach(function (s) {
            s.classList.remove("is-active");
          });
          swatch.classList.add("is-active");

          // Update the label for this group
          var colorLabel = card.querySelector('[data-klar-bundle-color-name="' + optionIndex + '"]');
          if (colorLabel) colorLabel.textContent = swatch.getAttribute("data-color-name");

          // Collect all currently active values per option index
          var selectedOptions = {};
          card.querySelectorAll(".klar-product-card__swatch.is-active").forEach(function (s) {
            var idx = parseInt(s.getAttribute("data-option-index"), 10);
            selectedOptions[idx] = s.getAttribute("data-option-value");
          });

          // Find the variant matching all selected options
          var matched = variants.find(function (v) {
            return Object.keys(selectedOptions).every(function (idx) {
              return v.options[parseInt(idx, 10)] === selectedOptions[idx];
            });
          });
          if (matched && variantInput) variantInput.value = matched.id;

          // Swap image if swatch has one
          var src = swatch.getAttribute("data-image-src");
          var srcset = swatch.getAttribute("data-image-srcset");
          var alt = swatch.getAttribute("data-image-alt");
          if (mainImg && src) {
            mainImg.src = src;
            if (srcset) mainImg.srcset = srcset;
            if (alt) mainImg.alt = alt;
          }
        });
      });

    } else {
      // Single-product: existing behavior
      var colorName = card.querySelector("[data-klar-color-name]");

      swatches.forEach(function (swatch) {
        swatch.addEventListener("click", function () {
          swatches.forEach(function (s) { s.classList.remove("is-active"); });
          swatch.classList.add("is-active");

          var variantId = swatch.getAttribute("data-variant-id");
          if (variantInput && variantId) variantInput.value = variantId;

          var name = swatch.getAttribute("data-color-name");
          if (colorName && name) colorName.textContent = name;

          var src = swatch.getAttribute("data-image-src");
          var srcset = swatch.getAttribute("data-image-srcset");
          var alt = swatch.getAttribute("data-image-alt");
          if (mainImg && src) {
            mainImg.src = src;
            if (srcset) mainImg.srcset = srcset;
            if (alt) mainImg.alt = alt;
          }
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll("[data-klar-product-card]").forEach(initCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Re-init after Shopify section re-render (theme editor)
  document.addEventListener("shopify:section:load", initAll);
})();
